import Vue from 'vue'
import App from './App.vue'
import router from './router'

//引入elementui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import showToast from 'my-showtoast'
Vue.use(showToast)

//Axios
import axios from 'axios'
axios.defaults.baseURL = 'http://www.ditingzixun.cn'
Vue.prototype.$axios = axios

Vue.use(ElementUI)

Vue.config.productionTip = false

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})
import Gobto from '../toboy'

Vue.prototype.Gobto = Gobto
new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app')
